/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs */

const en_forms_teams_settings_contact_can_redirect_contacts = /** @type {(inputs: Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redirect Contacts`)
};

const de_forms_teams_settings_contact_can_redirect_contacts = /** @type {(inputs: Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann Kontakte weiterleiten`)
};

/**
* | output |
* | --- |
* | "Redirect Contacts" |
*
* @param {Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_contact_can_redirect_contacts = /** @type {((inputs?: Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Contact_Can_Redirect_ContactsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_contact_can_redirect_contacts(inputs)
	return de_forms_teams_settings_contact_can_redirect_contacts(inputs)
});